/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import { useHover } from '@mantine/hooks';
import { Link } from 'react-router-dom';
import AppStack from '../../../../common/AppStack';
import { sterilizeUrlHandle } from '../../../../../helpers/format';
import AppText from '../../../../common/AppText';
import AppFlexbox from '../../../../common/AppFlexbox';

const WsCategoryCard = ({
  category,
  onNavigate,
  baseStoreUrl,
  colorScheme,
  mediaQueries,
  showIcon,
  isOutlineStyle,
  textAlign,
  fontSize,
  iconPosition,
  cardSize,
  isSubcategoryList
}) => {
  const { hovered, ref: hoverRef } = useHover();
  const alignText = textAlign ?? 'center';
  const isIconVisible = !isSubcategoryList && !!category?.Icon && showIcon;

  return (
    <AppStack
      ref={hoverRef}
      component={Link}
      onClick={onNavigate}
      style={{
        gap: 0,
        flex: 1,
        padding: 0,
        height: '100%',
        cursor: 'pointer',
        textDecoration: 'none',
        color:
          (isOutlineStyle
            ? colorScheme?.outlineButtonColor
            : colorScheme?.solidButtonLabel) ?? '#000'
      }}
      to={`${baseStoreUrl}/${
        isSubcategoryList ? 'sub-categories' : 'categories'
      }/${sterilizeUrlHandle(category?.name)}`}
    >
      <AppStack
        style={{
          position: 'relative',
          width: '100%',
          height: '100%',
          minHeight:
            cardSize === 'huge'
              ? 160
              : cardSize === 'extra_large'
              ? 140
              : cardSize === 'large'
              ? 120
              : cardSize === 'medium'
              ? 100
              : cardSize === 'small'
              ? 80
              : 60,
          border: isOutlineStyle
            ? `1px solid ${colorScheme?.outlineButtonColor}`
            : 'none',
          backgroundColor:
            (isOutlineStyle ? 'unset' : colorScheme?.solidButtonColor) ??
            '#f0f0f0',
          overflow: 'hidden',
          justifyContent: 'center',
          borderRadius: 8,
          padding: 12
        }}
      >
        <AppStack
          style={{
            gap: 8,
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
            flexDirection: iconPosition === 'top' ? 'column-reverse' : 'column'
          }}
        >
          <AppFlexbox
            style={{
              textAlign: alignText,
              flexDirection: alignText === 'right' ? 'row-reverse' : 'row',
              width: '100%',
              justifyContent: 'space-between',
              alignContent: 'center',
              alignItems: 'center',
              gap: 8
            }}
          >
            <AppText
              style={{
                fontSize: fontSize ?? 18,
                fontWeight: 500,
                width: '100%'
              }}
            >
              {category.name}
            </AppText>

            {isIconVisible && alignText !== 'center' && (
              <AppStack>
                <category.Icon size={22} />
              </AppStack>
            )}
          </AppFlexbox>

          {isIconVisible && alignText === 'center' && (
            <AppStack>
              <category.Icon size={22} />
            </AppStack>
          )}
        </AppStack>
      </AppStack>
    </AppStack>
  );
};

WsCategoryCard.propTypes = {
  baseStoreUrl: PropTypes.string,
  cardSize: PropTypes.string,
  category: PropTypes.object,
  colorScheme: PropTypes.object,
  fontSize: PropTypes.number,
  iconPosition: PropTypes.string,
  isOutlineStyle: PropTypes.bool,
  isSubcategoryList: PropTypes.bool,
  mediaQueries: PropTypes.object,
  onNavigate: PropTypes.func,
  showIcon: PropTypes.bool,
  textAlign: PropTypes.string
};

export default WsCategoryCard;
